import React from "react";

const TopNavbarBrand = props => {
  const { logo } = props;
  if (logo){
    return (
      <div className={"top-navbar-item brand"}>
        <div>
          <img className={"top-navbar-brand"} src={logo} alt="top-navbar-brand"/>
        </div>
      </div>
    );
  } else {
    return null
  }
  
};

export default TopNavbarBrand;
